// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"8bf72dd4","453":"bc4f47f4","760":"bc361318","828":"c9516095"}[chunkId] + ".chunk.js";
};